// database-backup-script.js - Backup current werkvormen data
import React, { useState } from 'react';
import { db } from '../firebase/config';
import { collection, getDocs } from 'firebase/firestore';

const createBackup = async () => {
  try {
    console.log('🔄 Starting database backup...');
    
    const backup = {
      timestamp: new Date().toISOString(),
      version: '1.0',
      collections: {}
    };

    // Backup tredes collection (questions + werkvormen)
    const tredesSnapshot = await getDocs(collection(db, 'tredes'));
    backup.collections.tredes = {};
    
    tredesSnapshot.forEach(doc => {
      backup.collections.tredes[doc.id] = {
        id: doc.id,
        data: doc.data()
      };
      console.log(`✅ Backed up trede: ${doc.id}`);
      
      // Log current werkvormen for verification
      const werkvormen = doc.data().werkvormen || [];
      console.log(`   Werkvormen count: ${werkvormen.length}`);
      werkvormen.forEach((wv, index) => {
        console.log(`   ${index + 1}. ${wv.title || 'Unnamed'}`);
      });
    });

    // Create downloadable backup file
    const backupJson = JSON.stringify(backup, null, 2);
    const blob = new Blob([backupJson], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    // Auto-download backup
    const a = document.createElement('a');
    a.href = url;
    a.download = `teamscan-backup-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    console.log('✅ Backup completed and downloaded!');
    console.log('📊 Backup summary:', {
      tredes: Object.keys(backup.collections.tredes).length,
      totalWerkvormen: Object.values(backup.collections.tredes)
        .reduce((total, trede) => total + (trede.data.werkvormen?.length || 0), 0)
    });

    return backup;
    
  } catch (error) {
    console.error('❌ Backup failed:', error);
    throw error;
  }
};

// Manual backup function voor console gebruik
export const manualBackup = createBackup;

// Component voor admin panel
export const BackupComponent = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [lastBackup, setLastBackup] = useState(null);

  const handleBackup = async () => {
    setIsCreating(true);
    try {
      const backup = await createBackup();
      setLastBackup(new Date().toLocaleString());
      alert('✅ Backup succesvol gedownload!');
    } catch (error) {
      alert('❌ Backup mislukt: ' + error.message);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      padding: '30px'
    }}>
      <h3 style={{ marginBottom: '20px', color: '#1f2937' }}>
        Database Backup
      </h3>
      
      <p style={{ color: '#6b7280', marginBottom: '20px' }}>
        Maak een backup van alle werkvormen data voordat je wijzigingen aanbrengt.
      </p>

      <button
        onClick={handleBackup}
        disabled={isCreating}
        style={{
          background: isCreating ? '#9ca3af' : '#3b82f6',
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '6px',
          cursor: isCreating ? 'not-allowed' : 'pointer',
          fontWeight: '600'
        }}
      >
        {isCreating ? '🔄 Backup maken...' : '💾 Download Backup'}
      </button>

      {lastBackup && (
        <p style={{ 
          marginTop: '15px', 
          fontSize: '14px', 
          color: '#059669' 
        }}>
          ✅ Laatste backup: {lastBackup}
        </p>
      )}
    </div>
  );
};